// Hero slider — translate track, autoplay, dots, arrows, touch swipe, pause on hover.
function initHeroSlider() {
  const root = document.getElementById('hero-slider');
  if (!root) return;
  const track = root.querySelector('.kb-hero-track');
  const slides = track ? track.querySelectorAll('.kb-hero-slide') : [];
  if (!track || slides.length < 2) return;

  const dots = root.querySelectorAll('[data-hero-dot]');
  const prev = root.querySelector('[data-hero-prev]');
  const next = root.querySelector('[data-hero-next]');
  const autoplayMs = parseInt(root.getAttribute('data-autoplay') || '0', 10);

  let index = 0;
  let timer = null;

  const goTo = (i) => {
    index = ((i % slides.length) + slides.length) % slides.length;
    track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
    dots.forEach((d, di) => d.classList.toggle('is-active', di === index));
  };
  const nextSlide = () => goTo(index + 1);
  const prevSlide = () => goTo(index - 1);

  const start = () => {
    if (!autoplayMs) return;
    stop();
    timer = setInterval(nextSlide, autoplayMs);
  };
  const stop = () => { if (timer) { clearInterval(timer); timer = null; } };

  if (prev) prev.addEventListener('click', () => { prevSlide(); start(); });
  if (next) next.addEventListener('click', () => { nextSlide(); start(); });
  dots.forEach((d) => d.addEventListener('click', () => {
    goTo(parseInt(d.getAttribute('data-hero-dot') || '0', 10));
    start();
  }));

  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);

  // Touch swipe
  let touchX = null;
  root.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; stop(); }, { passive: true });
  root.addEventListener('touchend', (e) => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX;
    if (Math.abs(dx) > 40) { dx < 0 ? nextSlide() : prevSlide(); }
    touchX = null;
    start();
  }, { passive: true });

  // Pauza gdy tab niewidoczny (żeby nie palić baterii)
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

  // Slajdy 2+ mają loading="lazy" (nie konkurują z obrazem LCP); po załadowaniu strony dociągamy je,
  // żeby zmiana slajdu nie mignęła pustym tłem.
  const eagerRest = () => slides.forEach((s) => s.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; }));
  if (document.readyState === 'complete') eagerRest(); else window.addEventListener('load', eagerRest, { once: true });

  start();
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initHeroSlider();
  else document.addEventListener('DOMContentLoaded', initHeroSlider);
}

export {};
